import cardIcon from '@/themes/neon/assets/images/icons/regular_card.svg'
import dateIcon from '@/themes/neon/assets/images/icons/regular_date.svg'
import idIcon from '@/themes/neon/assets/images/icons/regular_id.svg'
import nameIcon from '@/themes/neon/assets/images/icons/regular_name.svg'
import emailIcon from '@/themes/neon/assets/images/icons/regular_email.svg'
import caretIcon from '@/themes/neon/assets/images/icons/caret.svg'
import deleteIcon from '@/themes/neon/assets/images/icons/delete.svg'

window.KR_CONFIGURATION = {
  button: {
    template: `<span>{label} {price}</span>`,
    animation: `<krypton-button-animation type="spinning-squares" />`
  },
  fields: {
    icons: {
      regular: {
        pan: cardIcon,
        expiryDate: dateIcon,
        identityDocumentNumber: idIcon,
        cardHolderName: nameIcon,
        cardHolderMail: emailIcon
      },
      error: {
        pan: cardIcon,
        expiryDate: dateIcon,
        identityDocumentNumber: idIcon,
        cardHolderName: nameIcon,
        cardHolderMail: emailIcon
      },
      miscellaneous: {
        caret: caretIcon
      },
      delete: deleteIcon
    },
    custom: {
      template: `
        <div @show="isVisible" @class="{'kr-visible':isVisible, 'kr-focus':isFocused, 'kr-keyboard-focus':hasKeyboardFocus}" class="kr-field kr-text kr-field-wrapper">
          <div class="kr-icon" @class="{'kr-error':isInvalid}">
            <krypton-icon icon-class="fa fa-{attribute.kr-icon}"></krypton-icon>
          </div>
          <div class="kr-input-wrapper">
            {slot}
          </div>
        </div>`
    },
    checkbox: {
      type: 'switch',
      template: `
        <div @show="isVisible" @class="{'kr-visible':isVisible}" class="kr-field kr-checkbox kr-checkbox-type-switch">
          <div class="kr-field-wrapper">
            <div class="kr-checkbox-input-wrapper">
              <label class="kr-field-control kr-checkbox kr-label">
                {slot}
                <div class="kr-checkbox-control-indicator"></div>
                {attribute.label}
              </label>
            </div>
          </div>
        </div>`
    },
    radio: {
      template: `
        <div @show="isVisible" @class="{'kr-visible':isVisible}" class="kr-field kr-radio">
          {slot}
          <div class="kr-radio-control-indicator">
            <div class="kr-checked"></div>
          </div>
          <label for="{attribute.id}"> {attribute.label} </label>
        </div>`
    }
  },
  merchant: {
    header: {
      image: {
        type: 'logo',
        src: 'data:image/svg+xml;base64,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'
      },
      shopName: {
        color: '#444',
        visibility: true
      },
      orderId: {
        color: '#444',
        visibility: true
      },
      amount: {
        visibility: true
      },
      backgroundColor: '#F4F4F4'
    }
  },
  form: {
    brand: {
      visibility: true
    },
    placeholdersMinWidth: {
      securityCode: 110
    },
    error: {
      extra: {
        content: `<div class="kr-error-icon">
          <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.20164 18.4695L10.1643 4.00506C10.9021 2.66498 13.0979 2.66498 13.8357 4.00506L21.7984 18.4695C22.4443 19.6428 21.4598 21 19.9627 21H4.0373C2.54022 21 1.55571 19.6428 2.20164 18.4695Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 9V13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 17.0195V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>`
      }
    },
    wrapper: true,
    // redirection modal
    redirection: {
      backgroundColor: '#f4f4f4',
      border: '5px solid #f4f4f4',
      borderRadius: '5px',
      padding: '',
      header: {
        height: '30px',
        backgroundColor: '#f4f4f4',
        borderRight: '5px solid #f4f4f4',
        borderBottom: '5px solid #f4f4f4',
        borderLeft: '5px solid #f4f4f4',
        boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
        logo: {
          type: 'outline',
          width: '18px',
          height: '18px',
          fill: '#ffffff',
          backgroundColor: 'var(--kr-global-color-primary)',
          borderRadius: '50%',
          padding: '4px',
          position: 'left'
        },
        label: {
          fontFamily: `'Roboto', sans-serif`,
          position: 'center',
          visibility: true
        },
        closeBtn: {
          width: '18px',
          height: '18px',
          fill: 'var(--kr-global-color-primary)',
          border: null,
          margin: null
        }
      },
      fullscreen: {
        border: '0px',
        header: {
          height: '28px',
          padding: '5px 0 0 0',
          borderTopLeftRadius: '5px',
          borderTopRightRadius: '5px'
        }
      }
    },
    smartButton: {
      button: {
        spinnerVisible: true
      }
    },
    smartform: {
      overlay: {
        logo: {
          visibility: true
        }
      },
      modal: {
        borderTop: '5px',
        borderBottom: '5px',
        backButton: {
          height: '46px',
          $redirect: {
            height: '46px'
          }
        }
      },
      radioButton: {
        visibility: true
      }
    }
  },
  theme: {
    name: 'neon',
    version: 'V4.22.6'
  },
  smartForm: {
    otherPaymentMethodsLayout: {
      grid: {
        button: {
          $singlePaymentButton: {
            threshold: {
              small: 240
            }
          },
          minWidth: 60,
          paddingRight: 10,
          paddingY: 5
        }
      }
    },
    preferredPaymentMethodsLayout: {
      grid: {
        button: {
          $singlePaymentButton: {
            threshold: {
              small: 240
            }
          },
          minWidth: 60,
          paddingRight: 10,
          paddingY: 5
        }
      }
    }
  }
}
